<div class="container">
  <h2>Details bearbeiten</h2>
  <div class="item-form-container">

    <form [formGroup]="categoryForm" (ngSubmit)="onSubmit()">

      <div class="form-field">
        <mat-form-field>
          <mat-label>Bezeichner:</mat-label>
          <input matInput type="text" formControlName="identifier" />
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field>
          <mat-label>Text:</mat-label>
          <input matInput type="text" formControlName="text" />
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field>
          <mat-label>Sortierung:</mat-label>
          <input matInput type="number" formControlName="sortId" />
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-checkbox formControlName="showOnFrontend">Aktiv</mat-checkbox>
      </div>

      <div class="form-field">
        <mat-checkbox formControlName="allowComment">Kommentar erlauben</mat-checkbox>
      </div>

      <div class="form-field">
        <button mat-raised-button color="accent" type="submit" [disabled]="categoryForm.invalid">Speichern</button>
      </div>

    </form>
  </div>
  <mat-dialog-actions align="end">
    <!--    <button mat-button [mat-dialog-close]="comment" cdkFocusInitial>Ok</button>-->
    <button mat-button mat-dialog-close>Abbrechen</button>
  </mat-dialog-actions>
</div>
